import React from "react";
import SearchIcon from "@mui/icons-material/Search";
import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";

export interface SearchInputControledProps {
  onSubmitSearch: (Value: string) => void;
  value: string;
  onChangeValue: (newValue: string) => void;
  disabled?: boolean;
  placeholder?: string;
}
export function SearchInputControled({
  onSubmitSearch,
  value,
  onChangeValue,
  disabled = false,
  placeholder = "Pesquisar",
}: SearchInputControledProps) {
  return (
    <Paper
      component="form"
      onSubmit={(e) => {
        e.preventDefault();
        onSubmitSearch(value);
      }}
      sx={{ p: "2px 4px", display: "flex", alignItems: "center", maxWidth: "400px", width: "100%" }}
    >
      <InputBase
        sx={{ ml: 1, flex: 1 }}
        placeholder={placeholder}
        inputProps={{ "aria-label": "search" }}
        value={value}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChangeValue(e.target.value)}
        disabled={disabled}
      />
      <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
      <IconButton
        type="button"
        sx={{ p: "10px" }}
        aria-label="search"
        onClick={() => onSubmitSearch(value)}
        disabled={disabled}
      >
        <SearchIcon />
      </IconButton>
    </Paper>
  );
}

export default SearchInputControled;
